import useSettingsStore from '../store/useSettingsStore';
import { getTerm } from './terms';

/**
 * Hook returning a terminology helper bound to the active shop's type.
 * Usage: const { t, shopType, isMoto } = useTerms();  t('plural') -> "Motocicletas"
 */
export const useTerms = () => {
  const shopType = useSettingsStore((s) => s.settings?.shopType) || 'vehicles';
  return {
    shopType,
    isMoto: shopType === 'motorcycles',
    t: (key) => getTerm(key, shopType),
  };
};

export default useTerms;
